import React, { forwardRef } from 'react';
import { cn } from '../../../lib/utils';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  icon?: typeof LucideIcon;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  icon: Icon,
  error,
  className,
  ...props
}, ref) => {
  return (
    <div className="w-full group">
      {label && (
        <label className="block text-sm font-medium mb-2.5 text-gray-700 group-focus-within:text-indigo-600 transition-colors duration-200">
          <div className="flex items-center gap-2.5">
            {Icon && <Icon className="h-5 w-5 text-gray-400 group-focus-within:text-indigo-600 transition-colors duration-200" />}
            {label}
          </div>
        </label>
      )}
      <div className="relative">
        <textarea
          ref={ref}
          className={cn(
            "block w-full py-3 px-4 rounded-xl shadow-sm transition-all duration-200",
            "text-base placeholder:text-gray-400",
            "bg-white hover:bg-gray-50/50",
            "border-2 border-gray-200 hover:border-gray-300",
            "focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 focus:bg-white",
            "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500",
            "resize-none",
            error && "border-red-300 hover:border-red-400 focus:border-red-500 focus:ring-red-500/10",
            className
          )}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-2 text-sm font-medium text-red-600 animate-slideDown">
          {error}
        </p>
      )}
    </div>
  );
});

Textarea.displayName = 'Textarea';